import { createContext, useContext } from "react";

import { AuthContextProps } from "../types";

export const AuthContext = createContext<AuthContextProps>({
    user: null,
    loading: true,
    logout: () => {},
    token: null,
    storeId: null,
    accountId: null,
    updateStoreId: () => {},
    authConfig: null,
});

export const useAuth = () => {
    const context = useContext(AuthContext);

    if (!context)
        throw new Error("useAuth must be used within an AuthProvider");

    return context;
};
